/*
 * flashmeeting-fe
 *
 * Author: Andgel BRISSAUD
 * Copyright (c) 2024 Prodeo - All Rights Reserved
 */
/* ===== External Libraries ===== */
import { AXIOS, CallbackErrorAxios, CallbackWarningAxios, CommonGlobalService, dayjs, FORMAT_DATE_API, UUID } from '@umanforge/common';
import { AxiosResponse, AxiosError } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

/* ===== API Configuration ===== */
import { API } from 'constants/api.constant';

/* ===== Interfaces and Types ===== */

/* ===== Services ===== */
import { GlobalService } from './global.service';
import { ClosedDay } from 'interfaces/closedDays.interface';

export class ClosedDaysService {

  static getClosedDaysByEventManager(
    eventManagerId: UUID, page: number, step: number,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<{ total: number, datas: ClosedDay[] }> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.CLOSED_DAYS}/by-event-manager/${ eventManagerId }`, { ...await CommonGlobalService.getHeaderRequest( token ), params: { page, step } } )
        .then( ( response: AxiosResponse<{ total: number, datas: ClosedDay[] }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static isValidClosedDaysForEventManager(
    eventManagerId: UUID, closedDays: { startDate: dayjs.Dayjs, endDate: dayjs.Dayjs }[], excludedClosedDaysId: UUID[],
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<boolean> {
    return new Promise( async resolve => {
      const formatedDates = closedDays.map( dates => {
        return { startDate: dates.startDate.format( FORMAT_DATE_API ), endDate: dates.endDate.format( FORMAT_DATE_API ) };
      } );
      AXIOS.get( `${API.CLOSED_DAYS}/is-valid-closed-day-for-event-manager/${ eventManagerId }`, { ...await CommonGlobalService.getHeaderRequest( token ), params: { closedDays: formatedDates, excludedClosedDaysId } } )
        .then( ( response: AxiosResponse<{ isValidDates: boolean }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data.isValidDates );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

}